import React, { createContext, useContext, useEffect, useState } from "react";
import { db } from "../firebase";
import { doc, onSnapshot, setDoc } from "firebase/firestore";

const ShopStatusContext = createContext();

export function ShopStatusProvider({ children }) {
  const [status, setStatusState] = useState("open");

  useEffect(() => {
    let unsub;
    let timeoutId;
    
    const setupListener = () => {
      try {
        unsub = onSnapshot(
          doc(db, "settings", "main"), 
          (docSnap) => {
            if (docSnap.exists()) {
              setStatusState(docSnap.data().status || "open");
            }
          },
          (error) => {
            console.warn('ShopStatus listener error:', error);
            // Retry after 5 seconds on error
            timeoutId = setTimeout(() => {
              setupListener();
            }, 5000);
          }
        );
      } catch (error) {
        console.warn('Failed to setup ShopStatus listener:', error);
        // Fallback to default status
        setStatusState("open");
      }
    };
    
    setupListener();
    
    return () => {
      if (unsub) unsub();
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, []);

  const setStatus = async (status) => {
    await setDoc(doc(db, "settings", "main"), { status }, { merge: true });
  };

  return (
    <ShopStatusContext.Provider value={{ status, setStatus }}>
      {children}
    </ShopStatusContext.Provider>
  );
}

export function useShopStatus() {
  return useContext(ShopStatusContext);
}